import React from "react";

import Vacancy from "../SearchResults/Vacancy";

function ImageWithHeaderSingleJob() {
  return <Vacancy hasCategoryCard imageHeader showHead singleJobView />;
}

export default ImageWithHeaderSingleJob;
